export const ROUTES = {
  ROOT: '/',
  LINK_IN_BIO_USERNAME: '/:username',
};
